import { ProductColor } from '@ravago/shared/page-data/models/elements';

import { createParser } from 'nuqs';

import { getColorIdFromName, getColorNameFromId } from './color-utils';

export const parseAsColor = (colors: ProductColor[]) =>
   createParser<number | null>({
      parse(queryValue) {
         return getColorIdFromName(colors, queryValue) ?? null;
      },
      serialize(value) {
         if (!value) return '';
         return getColorNameFromId(colors, value) ?? '';
      }
   });

export const parseAsFlyoutState = createParser<boolean>({
   parse(queryValue) {
      return queryValue === 'open';
   },
   serialize(value) {
      return value ? 'open' : 'closed';
   }
});
